export const VIEWER_STORE_LINKS = {
    ios: 'https://apps.apple.com/us/app/ticketack-viewer/id6448471062',
    android: 'https://play.google.com/store/apps/details?id=ch.netoxygen.ticketack.ticketackviewer',
};
